export const environment = {
	production: true,

	auth: {
		url: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0/oauth2/v2.0',
		client_id: '53d7e4e8-b52b-49a5-b87d-cff0afacf369',
		redirect_uri: 'https://wings-mobile-qa-619078306104.us-central1.run.app',
		scope: 'openid profile email api://b5dab151-905b-4c52-bcdc-04ea9dcfcd34/webapp'
	},

	envName: 'qa',

	backend_url: 'https://api-qat.int.service.ford.com/wingsApiBackend',

	aps_request_url: 'https://wwwedu.accessmgmt.ford.com/CspsWeb/cspsHomeBegin.do',

	inbound_url: 'https://api-qat.service.ford.com/wingsInbound',

	backend_Jab_url: 'https://api-qat.int.service.ford.com/libertyProxy/'
};
